(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-footer"]) return;
  try {
    
function bgFooterMenus(){document.querySelectorAll('.bg-footer-menu').forEach(menu=>{menu.open=window.matchMedia('(min-width:750px)').matches;});}bgFooterMenus();window.matchMedia('(min-width:750px)').addEventListener('change',bgFooterMenus);document.addEventListener('shopify:section:load',bgFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bg-global-gifts"]) return;
  try {
    
(() => {
  const root = document.getElementById('BgOctoberCampaign');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const end = Date.parse(root.dataset.end);
  const storageKey = 'beargirls-october-2026-popup-shown';
  const day = 86400000;
  let previouslyFocused = null;
  let waitFinished = false;
  let interacted = false;
  let autoShown = false;
  const active = () => Date.now() < end;
  const expire = () => {
    if (dialog.open) dialog.close();
    document.querySelectorAll('[data-bg-october-content]').forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-bg-october-fallback],[data-bg-gift-ended]').forEach(el => { el.hidden = false; });
  };
  if (!active()) { expire(); return; }
  let expiryTimer = setTimeout(expire, Math.min(end - Date.now(), 2147483647));
  const hasRecentVisit = () => {
    try {
      const last = Number(localStorage.getItem(storageKey) || 0);
      return last > 0 && Date.now() - last < day;
    } catch { return true; }
  };
  const markShown = () => {
    try { localStorage.setItem(storageKey, String(Date.now())); } catch {}
  };
  const open = (trigger) => {
    if (!active()) { expire(); return false; }
    if (!dialog.showModal) return false;
    if (dialog.open) return true;
    previouslyFocused = trigger || document.activeElement;
    dialog.showModal();
    document.body.classList.add('bg-gift-dialog-open');
    markShown();
    dialog.querySelector('[data-bg-gift-close]').focus({preventScroll:true});
    return true;
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bg-gift-open]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (open(trigger)) event.preventDefault();
  });
  dialog.querySelectorAll('[data-bg-gift-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('bg-gift-dialog-open');
    if (previouslyFocused && previouslyFocused.isConnected) previouslyFocused.focus({preventScroll:true});
  });
  const autoPage = location.pathname === '/' || location.pathname.startsWith('/products/') || location.pathname.startsWith('/collections/');
  const tryAutoOpen = () => {
    if (autoShown || !waitFinished || !interacted || !autoPage || root.dataset.autoPopup !== 'true' || document.visibilityState !== 'visible' || hasRecentVisit()) return;
    const privacyBanner = document.getElementById('shopify-pc__banner');
    if (privacyBanner && privacyBanner.getClientRects().length > 0) return;
    if (document.querySelector('dialog[open],.drawer.active,.product-media-modal[open],.menu-drawer-container[open]')) return;
    autoShown = open();
  };
  const recordInteraction = () => { interacted = true; tryAutoOpen(); };
  document.addEventListener('pointerdown', recordInteraction, {passive:true});
  document.addEventListener('keydown', recordInteraction);
  document.addEventListener('scroll', () => { if (window.scrollY >= 120) recordInteraction(); }, {passive:true});
  document.addEventListener('visibilitychange', () => { if (active()) tryAutoOpen(); else expire(); });
  window.addEventListener('pageshow', () => {
    clearTimeout(expiryTimer);
    if (!active()) expire();
    else expiryTimer = setTimeout(expire, Math.min(end - Date.now(), 2147483647));
  });
  setTimeout(() => { waitFinished = true; tryAutoOpen(); }, 10000);
  window.addEventListener('pagehide', () => { clearTimeout(expiryTimer); }, {once:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
